"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateToV1 = void 0;
var lodash_1 = require("lodash");
var versions_1 = require("@wix/wix-vod-constants/dist/app-settings/versions");
var version_0_1 = require("./version-0");
/* Don't change settings here! To change settings behavior, create new version */
/* Starting from this version all settings are saved explicitly,
 giving us ability safely change defaults for new users */
function migrateToV1(appSettingsV0) {
    return (0, lodash_1.merge)({}, version_0_1.defaultSettingsV0, appSettingsV0, {
        numbers: {
            settingsVersion: versions_1.APP_SETTINGS_VERSION_1,
        },
    });
}
exports.migrateToV1 = migrateToV1;
//# sourceMappingURL=version-1.js.map